<template>
<v-flex class="form justify-center">
    <div style="width:30%">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col>
          <v-alert color="red" dismissible v-if="error" type="error">{{error}}</v-alert>
          <v-card class="elevation-12">
            <v-toolbar dark color="rgb(17, 25, 69)">
              <v-toolbar-title>Password Reset</v-toolbar-title>
              <v-spacer />
              <v-tooltip bottom />
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="resetPassword">
                <v-text-field
                  v-model="email"
                  prepend-icon="person"
                  name="login"
                  label="Email"
                  type="text"
                />
              </v-form>
               <div style="font-size: 1rem;">{{passwordMessage}}</div>
              
            </v-card-text>
            
            <v-card-actions>
              
              <v-spacer />
              <v-btn
                style="color: white; font-size: 1.2rem;"
                large
                color="rgb(17, 25, 69)"
                @click="resetPassword"
              >Reset</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    </div>
</v-flex>
</template>

<script>
 /* eslint-disable */ 
   import Axios from "axios";
  const base_link = 'https://tranquil-beyond-74281.herokuapp.com/';
export default {
  name: "PasswordForm",
  components: { },
  data() {
    return {
      email: "",
      password: "",
      snackbar: false,
      error: null,
      verified: false,
      passwordMessage:"",
    };
  },

  methods: {
    resetPassword: function() {
      if (this.email== '') {
        this.passwordMessage = "Please enter a valid email."
        return
      }

      var emailAddress = this.email;
  
      Axios.post(base_link + 'info/password/',{'email':this.email})
      .then((response)=>{
        console.log(response.data)
        if (response.data){
          this.passwordMessage="Email Sent. Please check your Inbox."
        }
        else{
          this.passwordMessage='An error occured. Make sure your email is correct.'
        }
    })
      
      const info = {
        email: this.email,
        password: this.password,
        error: this.error
      };
  }
  }
};
</script>
<style scoped>
a {  text-decoration: none;}
/* eslint-disable */
.form{
    display: flex;
    justify-content: center;
}
</style>
